import { Action, createReducer, on } from '@ngrx/store';
import {
  loadSupplierList,
  readAllSupplierListFailed,
  readAllSupplierListSuccess,
  resetSupplierList,
} from '../../actions/supplier-list/supplier-list.actions';
import { PaginationWithFiltersRequest } from '../../../../api/models/pagination-with-filters-request';
import { SupplierListV1 } from '../../../../api/models/supplier-list-v-1';

export interface SupplierListState {
  suppliers: SupplierListV1[];
  totalElements: number;
  lastPagination?: PaginationWithFiltersRequest;
  loading: boolean;
  loaded: boolean;
  error?: unknown;
}

export const initialState: SupplierListState = {
  suppliers: [],
  totalElements: 0,
  lastPagination: undefined,
  loading: false,
  loaded: false,
  error: undefined,
};

const supplierListReducer = createReducer(
  initialState,

  on(loadSupplierList, (state, { pagination }) => ({
    ...state,
    loading: true,
    error: undefined,
    lastPagination: pagination,
  })),

  on(readAllSupplierListSuccess, (state, { suppliers, totalElements }) => ({
    ...state,
    suppliers,
    totalElements,
    loading: false,
    loaded: true,
    error: undefined,
  })),

  on(readAllSupplierListFailed, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: true,
    error,
  })),

  on(resetSupplierList, () => initialState)
);

export function reducer(state: SupplierListState | undefined, action: Action) {
  return supplierListReducer(state, action);
}
